import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import CareerApplicationsPage from "@/pages/admin/CareerApplicationsPage";

export const Route = createFileRoute("/_admin/admin/careers")({
  head: () => pageHead("Admin · Careers", "AKIVA admin · careers portal.", "/admin/careers", true),
  component: CareerApplicationsPage,
});
